import Vue from 'vue'
import Router from 'vue-router'
import * as exam from './exam'
import * as distribution from './distribution'
import * as pin from './pintuan'
import * as signup from './signup'
import * as integral from './integral'
import {
  getUser
} from '@/common/js/cache'

const HomePage = () => import('@/page/HomePage')
const Live = () => import('@/page/Live')
const Lession = () => import('@/page/LessionPage')
const LessionDetail = () => import('@/page/lessionDetail')
const Learn = () => import('@/page/Learn')
const LearnDetail = () => import('@/page/LearnDetail')
const LessionList = () => import('@/page/LessionList')

const my = () => import('@/page/my')
const personInfo = () => import('@/page/personInfo')
const orderList = () => import('@/page/orderList')
const collect = () => import('@/page/collect')
const study = () => import('@/page/study')
const feedback = () => import('@/page/feedback')
const message = () => import('@/page/message')
const aboutme = () => import('@/page/aboutme')
const download = () => import('@/page/download')
const login = () => import('@/page/login')
//const register = () => import('@/page/register')
const watch = () => import('@/page/watch')
const notfound = () => import('@/page/notfound')
const pay = () => import('@/page/pay')
const payorder = () => import('@/page/payorder')
const address = () => import('@/page/address')

const packagelist = () => import('@/page/packagelist')
const certificate = () => import('@/page/certificate')
const agreement = () =>import('@/page/agreement')

const zlhomepage = () =>import('@/page/zhaolu/zlhomepage')
const navgativelist = () =>import('@/page/zhaolu/navgativelist')
const navgativedetail = () =>import('@/page/zhaolu/navgativedetail')
const enterpage = () =>import('@/page/zhaolu/enterpage')
const zlexamlist = () =>import('@/page/zhaolu/zlexamlist')
const report = () =>import('@/page/zhaolu/report')
const exampage = () =>import('@/page/zhaolu/exampage')
const examsheet = () =>import('@/page/zhaolu/examsheet')
const examorderpractice = () =>import('@/page/zhaolu/examorderpractice')
const wxgroup = () =>import('@/page/zhaolu/wxgroup')

const vipMember = () =>import('@/page/vip-member/vip-member')
const vipCourse = () =>import('@/page/vip-member/vip-course')
const vipCourseNew = () =>import('@/page/vip-member/vip-course-new')
const vipCourseRecord = () =>import('@/page/vip-member/vip-course-record')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      redirect: '/HomePage'
    },
    {
      path: '/HomePage',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/zlhomepage',
      name: 'zlhomepage',
      component: zlhomepage
    },
    {
      path: '/zlexamlist',
      name: 'zlexamlist',
      component: zlexamlist
    },


    {
      path: '/navgativelist',
      name: 'navgativelist',
      component: navgativelist
    },
    {
      path: '/navgativedetail',
      name: 'navgativedetail',
      component: navgativedetail
    },
    {
      path: '/enterpage',
      name: 'enterpage',
      component: enterpage
    },
    {
      path: '/report',
      name: 'report',
      component: report
    },
    {
      path: '/exampage',
      name: 'exampage',
      component: exampage
    },
    {
      path: '/examsheet',
      name: 'examsheet',
      component: examsheet
    },
    {
      path: '/examorderpractice',
      name: 'examorderpractice',
      component: examorderpractice
    },
    {
      path: '/wxgroup',
      name: 'wxgroup',
      component: wxgroup
    },
    // 课程列表页
    {
      path: '/LessionList',
      name: 'LessionList',
      component: LessionList
    },
    {
      path: '/Live',
      name: 'Live',
      component: Live
    },
    {
      path: '/Lession',
      name: 'Lession',
      component: Lession
    },
    {
      path: '/Learn',
      name: 'Learn',
      component: Learn
    },
    {
      path: '/LearnDetail',
      name: 'LearnDetail',
      component: LearnDetail
    },
    {
      path: '/LessionDetail',
      name: 'LessionDetail',
      component: LessionDetail
    },
    {
      path: '/my',
      name: 'My',
      component: my
    },
    {
      path: '/personinfo',
      name: 'personInfo',
      component: personInfo
    },
    {
      path: '/orderlist',
      name: 'orderList',
      component: orderList
    },
    {
      path: '/collect',
      name: 'collect',
      component: collect
    },
    {
      path: '/study',
      name: 'study',
      component: study
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/message',
      name: 'message',
      component: message
    },
    {
      path: '/aboutme',
      name: 'aboutme',
      component: aboutme
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: register
    // },
    {
      path: '/watch/:id',
      name: 'watch',
      component: watch
    },
    {
      path: '*',
      name: 'notfound',
      component: notfound
    },
    {
      path: '/pay/:id',
      name: 'pay',
      component: pay
    },
    {
      path: '/payorder',
      name: 'payorder',
      component: payorder
    },
    {
      path: '/address',
      name: 'address',
      component: address
    },
    {
      path: '/packagelist', //package 类型
      name: 'packagelist',
      component: packagelist
    },
    // 考试一类
    {
      path: '/examCourse',
      name: 'examCourse',
      component: exam.EXAM_COURSE
    },
    {
      path: '/exam',
      name: 'exam',
      component: exam.EXAM_HOME,
    },
    {
      path: '/DayPractice',
      name: 'DayPractice',
      component: exam.DAY_PRACTICE
    },
    {
      path: '/TrueTopic',
      name: 'TrueTopic',
      component: exam.TRUE_TOPIC
    },
    {
      path: '/Assessment',
      name: 'Assessment',
      component: exam.ASSESSMENT
    },
    {
      path: '/Wrong',
      name: 'Wrong',
      component: exam.WRONG
    },
    {
      path: '/CollectTopic',
      name: 'CollectTopic',
      component: exam.COLLECT
    },
    {
      path: '/QuestionRecord',
      name: 'QuestionRecord',
      component: exam.QUESTION_RECORD
    },
    {
      path: '/AnswerSheet',
      name: 'AnswerSheet',
      component: exam.ANSWER_SHEET
    },
    {
      path: '/ExamChapter',
      name: 'ExamChapter',
      component: exam.EXAM_CHAPTER
    },
    {
      path: '/ExamStartChapter',
      name: 'ExamStartChapter',
      component: exam.EXAM_CHANPTER_START
    },
    {
      path: '/MockExamList',
      name: 'MockExamList',
      component: exam.MOCK_EXAM_LIST
    },
    {
      path: '/StartMockExam',
      name: 'StartMockExam',
      component: exam.MOCK_EXAM
    },
    {
      path: '/StartTrueExam',
      name: 'StartTrueExam',
      component: exam.START_TRUE_EXAM
    },
    {
      path: '/WrongAnlysis',
      name: 'WrongAnlysis',
      component: exam.WRONG_ANALYSIS
    },
    // 考试报名
    {
      path:"/signlist",
      name:"signlist",
      component:signup.SIGNUP_LIST
    },
    {
      path: '/signupmsg',
      name: 'signUpMsg',
      component: signup.SIGNUP_MSG
    },
    {
      path: '/signupmsgdetail',
      name: 'signupmsgdetail',
      component: signup.SIGNUP_DETAIL
    },
    {
      path: '/chooseregion',
      name: 'chooseregion',
      component: signup.CHOOSE_REGION
    },
    // {
    //   path:"/checkup",
    //   name:"checkup",
    //   component:signup.CHECK_UP
    // },

    {
      path: '/pin',
      component: pin.PIN,
      children: [{
          path: 'pindetail',
          name: 'PIN_DETAIL',
          component: pin.PIN_DETAIL
        },
        {
          path: 'mypin',
          name: 'PIN_MY',
          component: pin.PIN_MY
        },
        {
          path: 'pinsuccess',
          name: 'PIN_SUCCESS',
          component: pin.PIN_SUCCESS
        },
        {
          path: 'pinstatus',
          name: 'PIN_STATUS',
          component: pin.PIN_STATUS
        },
        {
          path: 'pinorder',
          name: 'PIN_ORDER',
          component: pin.PIN_ORDER
        }
      ]
    },
    {
      path: '/saleuser',
      name: 'saleuser',
      component: distribution.saleuser
    },
    {
      path: '/income',
      name: 'income',
      component: distribution.income
    },
    {
      path: '/posterlist',
      name: 'posterlist',
      component: distribution.posterlist
    },
    {
      path: '/postershare',
      name: 'postershare',
      component: distribution.postershare
    },
    {
      path: '/widthdraw',
      name: 'widthdraw',
      component: distribution.widthdraw
    },
    {
      path: '/selectway',
      name: 'selectway',
      component: distribution.selectway
    },
    {
      path:'/certificate',
      name:'/certificate',
      component:certificate
    },
    {
      path:'/agreement',
      name:'/agreement',
      component:agreement
    },
    {
      path:'/integral',
      name:'integral',
      component:integral.integral
    },
    {
      path:'/integrallist',
      name:'integrallist',
      component:integral.integrallist
    },
    {
      path:'/vip-member',
      name:'vip-member',
      component:vipMember
    },
    {
      path:'/vip-course',
      name:'vip-course',
      component:vipCourse
    },
    {
      path:'/vip-course-new',
      name:'vip-course-new',
      component:vipCourseNew
    },
    {
      path:'/vip-course-record',
      name:'vip-course-record',
      component:vipCourseRecord
    }
    
  ]
})


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


let routeList = ['certificate','PIN_DETAIL','PIN_MY','PIN_SUCCESS','PIN_STATUS','examCourse', 'exam', 'DayPractice', 'TrueTopic', 'Assessment', 'Wrong', 'CollectTopic', 'QuestionRecord', 'AnswerSheet', 'ExamChapter', 'ExamStartChapter', 'MockExamList', 'StartMockExam', 'StartTrueExam', 'WrongAnlysis','integral']

// 路由守卫
// 进入特定页面前判断是否已登录，未登录跳转到登录页面
router.beforeEach((to, from, next) => {
  if (routeList.indexOf(to.name) > -1) {
    if (!getUser()) {
      console.log('this.$router')
      next({
        name: 'login'
      })
    }
  }
  next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js